import React, { useState } from "react";
import { Tooltip } from "@mui/material";

const WeLoveHumansTooltip = ({ title, isOnboarding = false, isMobile = false, children, customStyles, isDismissedView }) => {
  const [isOpenForMobile, setOpenForMobile] = useState(false);

  const handleTooltipOpen = () => {
    setOpenForMobile(true);
  };

  const handleTooltipClose = () => {
    setOpenForMobile(false);
  };

  const onboardingProps = (isOnboarding && isMobile)
  ? {
      open: isOpenForMobile,
      onClick: handleTooltipOpen,
      onClose: handleTooltipClose,
      disableTouchListener: true,
    }
  : {};

  return (
    <Tooltip
      title={
        <>
          <span>{title}</span>
          <span className="MuiTooltip-arrow" />
        </>
      }
      placement="top"
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            position: 'relative',
            backgroundColor: '#AFC6DF',
            width: 'auto',
            maxWidth: isOnboarding ? "500px" : "none",
            minHeight: '60px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '30px 30px 30px 29.5px',
            padding: '16px',
            color: 'black',
            wordWrap: 'break-word',
            textAlign: 'center',
            border: isDismissedView ? '1px solid black' : 'none',
            ...customStyles,
            '& .MuiTooltip-arrow': {
              color: '#AFC6DF',
              '&::before': {
                border: isDismissedView ? '1px solid black' : 'none',
            }
            },
          },
        },
      }}
      {...onboardingProps}
    >
      {children}
    </Tooltip>
  );
};

export default WeLoveHumansTooltip;